export default __webpack_public_path__ + "static/media/noData.690faeeb.svg";